<div #tooltip [class]="getClasses()" data-testid="tooltip-container" role="tooltip">
  @if (template()) {
    <div class="tooltip__complex">
      <ng-container *ngTemplateOutlet="template(); context: templateContext() ?? null" />
    </div>
  } @else {
    <span class="tooltip__text">{{ message() }}</span>
  }
  <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
  <span class="tooltip__chevron" [style]="indicatorPositionStyle()"></span>
</div>
